// This is a hack to make standalone components re-render on every triggered action.
// At this time, this helps render tooltips on standalone components which do not listen to any state (store) changes

const INITIAL_STATE = {
    component: 0
};

export const getComponent = (state) => {
    return state.component;
};

export default function component(state = INITIAL_STATE) {
    return {
        component: state.component + 1
    };
}
